<template>
    <filter-list-element
        v-for="(element, index) in inputItems"
        v-model="inputItems[index]"
        :key="'filt_'+index"
        :input-index="index"
        :parent-id="undefined"
        :parent-name="''"
        :parent-idx="'filt_'+index"
    />
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-facing-decorator';
import FilterListElement from '@/components/common/filter-list/FilterListElement.vue';
import _ from 'lodash';

@Component({
  name: 'AnalyticsFilterList',
  components: { FilterListElement }
})
export default class AnalyticsFilterList extends Vue {
    @Prop({ default: [] })
    inputItems!: any[]

    created() {
        //
    }
}
</script>